import { groupBy, map } from 'ramda';
import { ActionDTO } from 'services/dto/action';

export const generateRandomNum = (min, max) =>
  Math.floor(Math.random() * (max - min + 1) + min);

export const getTwitterIDFromUrl = twitterUrl => {
  const match = twitterUrl.match(
    /https?:\/\/twitter.com\/[a-zA-Z_]{1,20}\/status\/([0-9]*)/
  );
  return match && match[1];
};

export const groupByType = groupBy(item => {
  return item.type || 'default';
});

export const convertListofActionsToActionDTO = map(item => new ActionDTO(item));



// WEBPACK FOOTER //
// ./src/services/data-utils.js